/* Lunarness Mega Menu — desktop hover intent and accessible mobile drill-down. */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-lnmm-ready') === 'true') return;
    root.setAttribute('data-lnmm-ready', 'true');

    var CLOSE_DELAY = 130;
    var closeTimer = null;
    var items = [].slice.call(root.querySelectorAll('[data-lnmm-item]'));
    var touchLike = window.matchMedia('(hover: none)').matches;
    var drawer = root.querySelector('[data-lnmm-drawer]');
    var burger = root.querySelector('[data-lnmm-open]');
    var lastFocused = null;

    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var link = item.querySelector('.lnmm-item__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    function open(item) {
      window.clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      var link = item.querySelector('.lnmm-item__link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        closeAll(null);
      }, CLOSE_DELAY);
    }

    function focusableInDrawer() {
      if (!drawer) return [];
      return [].slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) {
          return element.offsetParent !== null;
        });
    }

    function openDrawer() {
      if (!drawer || !burger) return;
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lnmm-locked');
      window.requestAnimationFrame(function () {
        var closeButton = drawer.querySelector('[data-lnmm-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }

    function closeDrawer(restoreFocus) {
      if (!drawer || !burger) return;
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lnmm-locked');
      var sheet = drawer.querySelector('.lnmm-drawer__sheet');
      if (sheet) sheet.scrollLeft = 0;
      [].forEach.call(drawer.querySelectorAll('[data-lnmm-sub]'), function (subPanel) {
        subPanel.classList.remove('is-active');
      });
      if (wasOpen && restoreFocus !== false && lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    }

    items.forEach(function (item) {
      var link = item.querySelector('.lnmm-item__link');
      if (!link) return;

      if (!touchLike) {
        item.addEventListener('mouseenter', function () { open(item); });
        item.addEventListener('mouseleave', scheduleClose);
      }

      link.addEventListener('click', function (event) {
        /* First touch/keyboard activation opens; a second activation follows the link. */
        if (!item.classList.contains('is-open')) {
          event.preventDefault();
          open(item);
        }
      });

      link.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open(item);
          var firstPanelLink = item.querySelector('[data-lnmm-panel] a');
          if (firstPanelLink) firstPanelLink.focus();
        }
      });
    });

    if (drawer && burger) {
      burger.addEventListener('click', openDrawer);

      [].forEach.call(drawer.querySelectorAll('[data-lnmm-close]'), function (button) {
        button.addEventListener('click', function () { closeDrawer(true); });
      });

      [].forEach.call(drawer.querySelectorAll('[data-lnmm-drill]'), function (button) {
        button.addEventListener('click', function () {
          var subPanel = drawer.querySelector('#' + button.getAttribute('data-lnmm-drill'));
          if (!subPanel) return;
          var sheet = drawer.querySelector('.lnmm-drawer__sheet');
          if (sheet) sheet.scrollLeft = 0;
          subPanel.classList.add('is-active');
          var backButton = subPanel.querySelector('[data-lnmm-back]');
          if (backButton) {
            window.requestAnimationFrame(function () {
              backButton.focus({ preventScroll: true });
            });
          }
        });
      });

      [].forEach.call(drawer.querySelectorAll('[data-lnmm-back]'), function (button) {
        button.addEventListener('click', function () {
          var subPanel = button.closest('[data-lnmm-sub]');
          if (!subPanel) return;
          subPanel.classList.remove('is-active');
          var sheet = drawer.querySelector('.lnmm-drawer__sheet');
          if (sheet) sheet.scrollLeft = 0;
          var trigger = drawer.querySelector('[data-lnmm-drill="' + subPanel.id + '"]');
          if (trigger) trigger.focus({ preventScroll: true });
        });
      });

      drawer.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
        var focusable = focusableInDrawer();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      var desktopQuery = window.matchMedia('(min-width: 990px)');
      var handleDesktopChange = function (event) {
        if (event.matches) closeDrawer(false);
      };
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', handleDesktopChange);
      else desktopQuery.addListener(handleDesktopChange);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAll(null);
      closeDrawer(true);
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll(null);
    });
  }

  function boot(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    if (container.matches && container.matches('[data-lnmm]')) init(container);
    [].forEach.call(container.querySelectorAll('[data-lnmm]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
